
const randomBoolean = () => Math.random() > 0.50;

export default { randomBoolean };
